module.exports = __webpack_public_path__ + "src/assets/games/10/599.jpg";